// extracted by mini-css-extract-plugin
export default {"root":"src-views-common-components-ToggleButton-ToggleButton__root--PXgZU"};